import { createContext, useContext } from "react";

const DraftOwner = createContext<string | null>(null);

export function DraftOwnerProvider({
  account,
  children,
}: {
  account: string | null;
  children: React.ReactNode;
}) {
  return <DraftOwner.Provider value={account}>{children}</DraftOwner.Provider>;
}

export function useDraftOwner(): string {
  const account = useContext(DraftOwner);
  if (!account) throw new Error("a Composer needs a signed-in draft owner");
  return account;
}
